import { Container } from 'components/layout'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'

export default function AppSettingsLayout() {
  return (
    <Container narrow>
      <Suspense>
        <Outlet />
      </Suspense>
    </Container>
  )
}
